
import Vue from "vue";
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {
    PossibleToApplyForConcessionPermit, ResultError,
    StartApplyingOrChangeTypeClient,
    StartApplyingForConcessionPermitRequest
} from "@/api-client";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import Loader from "@/features/shared/components/Loader";
import { Prop } from "vue-property-decorator";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";

interface Props {
    seafarerId: string;
    btnClass: string;
}

@Component({
    components: {
        ButtonWithConfirm,
        HeadingWave,
        SectionPageHeading,
        TableEmptySlot
    }
})
export default class ConcessionPermitTypeTable extends Vue implements Props {
    @Prop({ required: true })
    seafarerId!: string;
    @Prop({ required: false, default: 'btn-wide' })
    btnClass!: string;

    error: ResultError | null = null;
    applicationTypes: PossibleToApplyForConcessionPermit[] = [];
    searchQuery = '';

    loader = new Loader();

    fields = [
        { key: 'name', label: this.$ls.Global_Label_CertificateTypeName, sortable: true },
        { key: 'endorsementNumber', label: this.$ls.Global_Label_EndorsementNumber, sortable: true },
        { key: 'documentTypeCode', label: this.$ls.Global_Label_DocumentType, sortable: true },
        { key: 'linkIcon', label: '', sortable: false, thClass: 'w-20', tdClass: 'table-actions' }
    ];

    async created() {
        this.applicationTypes = await new StartApplyingOrChangeTypeClient().getConcessionPermitsToApplyFor(this.seafarerId);
    }

    get filteredApplicationTypes(): PossibleToApplyForConcessionPermit[] {
        if (!this.searchQuery || this.searchQuery.trim() === '') {
            return this.applicationTypes;
        }

        const query = this.searchQuery.toLowerCase().trim();
        return this.applicationTypes.filter(item =>
            item.endorsementNumber.toLowerCase().includes(query)
        );
    }

    startApplyingForConcessionPermit(templateId: string, endorsementId: string) {
        this.error = null;

        const request = new StartApplyingForConcessionPermitRequest({
            templateId,
            endorsementId
        });
        new StartApplyingOrChangeTypeClient()
            .setLoader(this.loader)
            .startApplyingForConcessionPermit(request, this.seafarerId)
            .then(result => this.$router.push({
                name: "ApplicationOverview",
                params: { applicationId: result.applicationId }
            }), error => this.error = error);
    }
}
